export default __webpack_public_path__ + "static/floral-2-7b5ca3f80f66ad28634753424ccdb3da.webp";